import { render, staticRenderFns } from "./BatchActions.vue?vue&type=template&id=ea94d2f0&scoped=true&"
import script from "./BatchActions.vue?vue&type=script&lang=js&"
export * from "./BatchActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea94d2f0",
  null
  
)

export default component.exports